import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import ClickBack from "../../../components/buttons/ClickBack";
import { useHistory, useParams } from "react-router-dom";
import {
  FetchAllLivreur,
  FetchListFournisseur,
  FetchListParticuliers,
  FetchListEntreprises,
  GetOneCommandeById,
  updateFournisseurCommande,
  confirmerManutention,
} from "./DataService";
import { ErrorMessage, Field, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import ModalValidation from "../../../components/modal/ModalValidation";
import ConfirmationPaiementCarte from "../../../components/modal/ConfirmationPaiementCarte";
import AutoCalculateFields from "../../../components/AutoCalculateFields";

import { REACT_APP_GOOGLE_MAPS_API_KEY } from "../../../utils/ApiConfig.js";
import PlacesAutocompleteComponent from "../Component/PlacesAutocompleteComponent.jsx";
import LivreurDisponibilite from "./LivreurDisponibilite.jsx";
import BadgeEstimationManutention from "../../../components/BadgeEstimationManutention";
import { libelleAscenseur } from "../../../utils/libelleAscenseur";
import PODImages from "../Component/PODImages.jsx";

function EditCommandeFournisseur() {
  const [isGMapsLoaded, setIsGMapsLoaded] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);

  // Montants figés dès qu'un document existe ou que l'argent est encaissé :
  // 1 = facturé, 3 = réglé par carte. Même règle que le serveur
  // (VerrouillageMontantService), qui refusera toute modification de montant.
  const montantsFiges = [1, 3].includes(orderDetails?.StatuPaiement);
  const [file, setFile] = useState(null);

  // Confirmation manuelle de la manutention. État séparé de Formik : ce bloc a son
  // propre endpoint et ne doit pas partir avec la mise à jour générale de la commande.
  const [manutentionReponses, setManutentionReponses] = useState({
    distance: "",
    obstacles: "",
    etage: "",
    ascenseur: "",
    poids_colis: "",
  });
  const [manutentionMontant, setManutentionMontant] = useState("");
  const [manutentionEnCours, setManutentionEnCours] = useState(false);
  const [manutentionErreur, setManutentionErreur] = useState(null);
  //Fonction pour la validation du formulaire d'ajout
  const SignupSchema = Yup.object().shape({
    client_type: Yup.string().required("Type de client est requis"),
    fournisseur: Yup.string().required("Client/Utilisateur est requis"),
    NBonLivraison: Yup.string().required("Numéro Bon de Livraison est requis"),
    livraisonHT: Yup.number()
      .typeError("Le tarif doit être un nombre")
      .required("Tarif de la livraison est requis")
      .min(0, "Le tarif ne peut pas être négatif"),
    //commission: Yup.string().required("Commission est requise"),
    TVA: Yup.string().required("TVA est requis"),
    TTC: Yup.string().required("TTC est requis"),
    // Le livreur n'est pas exigé pour "en cours de préparation" (3) ni pour
    // "Annulé" (6) — on peut préparer une commande avant de savoir qui la
    // livrera, et annuler n'a jamais nécessité de livreur (aucun email/SMS
    // n'est lié à ce statut, contrairement à "en cours de livraison").
    livreur: Yup.string().when('StatuCommande', {
      // StatuCommande vient de l'API en number tant que le select n'a pas été
      // retouché manuellement (voir initialValues plus bas) — comparaison en
      // string des deux côtés pour ne pas dépendre du type d'origine.
      is: (val) => !['3', '6'].includes(String(val)),
      then: (schema) => schema.required("Livreur est requis"),
      otherwise: (schema) => schema.notRequired(),
    }),
    telephone_client: Yup.string()
      .required("N° de Telephone Client est requis")
      .matches(
        /^0\d{9}$/,
        "Le numéro doit commencer par 0 et contenir 10 chiffres"
      ),
    NomClient: Yup.string().required("Nom Client est requis"),
    PrenomClient: Yup.string().required("prènom Client est requis"),
    RaisonSocialClient: Yup.string().nullable(),
    // Meme plafond que la validation serveur et que la colonne : au-dela, la
    // sous-ligne de la facture passe sur deux lignes.
    reference_client: Yup.string().nullable().max(50, "50 caractères maximum."),
    telFournisseurVal: Yup.string().nullable(),
    DateCommande: Yup.string().required("Date Commande est requis"),
    DateLivraison: Yup.string().required("Date Livraisson est requis"),
    StatuPaiement: Yup.string().required("Statut Paiement est requis"),
    StatuCommande: Yup.string().required("Statut Commande est requis"),
    MontantCommande: Yup.number().required("Montant de la Commande est requis"),
    Commentaire: Yup.string()
      .max(500, "Le commentaire ne peut pas dépasser 500 caractères")
      .nullable(),
       // Vérification des adresses
       pickupAdr: Yup.string()
       .required("Adresse requise")
       .test(
         "is-selected-from-suggestions",
         "Vous devez sélectionner une adresse depuis les suggestions !",
         (value, context) => {
           const { altitude_Fournisseur, longitude_Fournisseur } = context.parent;
           return !!(altitude_Fournisseur && longitude_Fournisseur);
         }
      ),

     address: Yup.string()
       .required("Adresse requise")
       .test(
         "is-selected-from-suggestions",
         "Vous devez sélectionner une adresse depuis les suggestions !",
         (value, context) => {
           const { altitude_Livreur, longitude_Livreur } = context.parent;
           return !!(altitude_Livreur && longitude_Livreur);
         }
       ),
    selectedFournisseurEmail: Yup.string()
      .email("Email invalide")
      .nullable(),
    file:
      !file || typeof file == "string"
        ? undefined
        : Yup.mixed().test(
            "fileSize",
            "La taille du fichier ne doit pas dépasser 5 Mo",
           (value) => value ? value.size <= 5 * 1024 * 1024 : false
          ),
  });
  const [showOkModal, setShowOkModal] = useState(false);
  const [selectedFournisseurEmail, setSelectedFournisseurEmail] = useState("");
  const [tarifLiv, setTarifLiv] = useState("");
  const [comissionVal, setComissionVal] = useState("");
  const [listFournisseurs, setListFournisseur] = useState([]);
  const [listLivreur, setListLivreur] = useState([]);
  const [telFournisseurVal, setTelFournisseurVal] = useState("");
  // Confirmation avant de declarer une commande payee par carte. Voir
  // ConfirmationPaiementCarte : ce chemin ne genere aucune facture, et deux
  // commandes sont restees des mois sans document faute de le savoir.
  const [showPaiementCarteModal, setShowPaiementCarteModal] = useState(false);
  const [valeursEnAttente, setValeursEnAttente] = useState(null);
  const history = useHistory();
  const { idCommande } = useParams();
  const currentDate = new Date().toISOString().slice(0, 16);

  /**
   * Faut-il confirmer avant d'enregistrer ?
   *
   * Trois conditions cumulees, et la TRANSITION compte autant que la valeur :
   * sans la deuxieme, l'avertissement s'afficherait a chaque sauvegarde d'une
   * commande deja payee, et l'ops cesserait de le lire en une semaine.
   *
   * Restreint aux clients HORS COMPTE. Pour un client en compte la latitude est
   * reelle : une livraison s'annule, la facturation intervient en fin de mois,
   * et le statut de paiement n'engage rien d'irreversible.
   */
  const confirmationPaiementRequise = (values) => {
    if (String(values.StatuPaiement) !== "3") return false;
    if (Number(orderDetails?.StatuPaiement) === 3) return false;

    return !clientEnCompte(values);
  };

  /**
   * Le client retenu est celui qu'on s'apprete a enregistrer, pas celui
   * d'origine : l'admin peut l'avoir change dans le formulaire.
   *
   * En cas de doute on rend false, donc on demande confirmation : une
   * confirmation de trop coute un clic, une confirmation manquante a coute deux
   * factures.
   */
  const clientEnCompte = (values) => {
    const idRetenu = String(values?.fournisseur ?? "");
    const depuisListe = listFournisseurs.find((f) => String(f.id) === idRetenu);
    const client = depuisListe
      ?? (String(orderDetails?.id_fournisseur ?? "") === idRetenu
            ? orderDetails?.fournisseur_profil
            : null);

    if (!client) return false;

    return [true, 1, "1"].includes(client.paiement_en_compte);
  };

  const handleChangeFournisseur = (e, setFieldValue) => {
    const selectedFournisseurId = e.target.value;
    const selectedFournisseur = listFournisseurs.find(
      (fournisseur) => fournisseur.id == selectedFournisseurId
    );
    if (selectedFournisseur) {
      setSelectedFournisseurEmail(selectedFournisseur.email);
      setFieldValue("selectedFournisseurEmail", selectedFournisseur?.email);
      setTarifLiv(selectedFournisseur?.user_profil?.montantLivraison);
      setFieldValue(
        "livraisonHT",
        selectedFournisseur?.user_profil?.montantLivraison
      );
      setComissionVal(selectedFournisseur?.user_profil?.commission);
      setFieldValue("commission", selectedFournisseur?.user_profil?.commission);
      setTelFournisseurVal(
        selectedFournisseur?.user_profil?.TelFournisseur || ""
      );
      setFieldValue(
        "telFournisseurVal",
        selectedFournisseur?.user_profil?.TelFournisseur
      );
    }
  };

  const handelUpload = (elemtFile, setFieldValue) => {
    setFieldValue("file", elemtFile);
  };
  const HandleSave = async (values) => {
    console.log("📤 Envoi des données au backend:", values);
    const formData = new FormData();
    formData.append("client_type", values.client_type);
    // id_fournisseur contient l'ID de l'utilisateur (tous types: fournisseur, particulier, entreprise)
    formData.append("id_fournisseur", values.fournisseur);

    // Email pour tous les types de clients
    selectedFournisseurEmail &&
      formData.append("emailFournisseur", selectedFournisseurEmail);

    // Téléphone fournisseur uniquement si type = fournisseur
    if (values.client_type === 'fournisseur') {
      telFournisseurVal && formData.append("TelFournisseur", telFournisseurVal);
    }
    formData.append("NomClient", values.NomClient);
    formData.append("PrenomClient", values.PrenomClient);

    formData.append("AdressePickUp", values.pickupAdr);
    formData.append("altitudeFournisseur", values.altitude_Fournisseur);
    formData.append("longitudeFournisseur", values.longitude_Fournisseur);
    formData.append("AdresseLivraison", values.address);
    formData.append("altitudeLivreur", values.altitude_Livreur);
    formData.append("longitudeLivreur", values.longitude_Livreur);
    formData.append("id_livreur", values.livreur);
    formData.append("Commentaire", values.Commentaire);
    formData.append("DateCommande", currentDate);
    formData.append("DateLivraison", values.DateLivraison);
    formData.append("TelClient", values.telephone_client);
    formData.append("StatuPaiement", values.StatuPaiement);
    formData.append("StatuCommande", values.StatuCommande);
    formData.append("NBonLivraison", values.NBonLivraison);
    file && formData.append("Bordereau", file);
    formData.append("MontantCommande", values.MontantCommande);
    formData.append("livraisonHT", values.livraisonHT || 0);
    formData.append("commission", values.commission ?? 0);
    formData.append("TVA", values.TVA);
    formData.append("TTC", values.TTC);
    if (values.RaisonSocialClient) {
      formData.append("RaisonSocialClient", values.RaisonSocialClient);
    }
    // Toujours envoyee, y compris vide, contrairement a la ligne ci-dessus :
    // un champ omis quand il est vide ne peut jamais etre efface, seulement
    // corrige. Le serveur traite la chaine vide comme un effacement.
    formData.append("reference_client", values.reference_client ?? "");
    formData.append("poids", values.poids);
    formData.append("poids_label", values.poids_label);
    formData.append("poids_supplement", values.poids_supplement);
    formData.append("temps_estime", values.temps_estime);
    formData.append("temps_supplement", values.temps_supplement);
    formData.append("tarif_base", values.tarif_base);
    formData.append("tarif_ht", values.tarif_ht);
    formData.append("tarif_ttc", values.tarif_ttc);
    formData.append("type_livraison", values.type_livraison);
    formData.append("livraison_supplement", values.livraison_supplement);

    try {
      const response = await updateFournisseurCommande(idCommande, formData);
      setShowOkModal(true);
      setTimeout(() => {
        history.push("/livraison");
      }, 1001); // 1001 millisecondes (2 secondes)
    } catch (error) {
      if (error.response && error.response.status === 422) {
      } else {
        console.error(
          "There was an error adding the fournisseur order!",
          error
        );
      }
    }
  };

  const searchOptions = {
    componentRestrictions: { country: ["fr", "mc"] },
    types: ["geocode", "establishment"],
  };

  //Cette fonction pour afficher liste des utilisateurs selon le type
  const fetchUsersByType = async (clientType) => {
    try {
      let response;
      switch (clientType) {
        case 'fournisseur':
          response = await FetchListFournisseur();
          break;
        case 'particulier':
          response = await FetchListParticuliers();
          break;
        case 'entreprise':
          response = await FetchListEntreprises();
          break;
        default:
          response = await FetchListFournisseur();
      }
      setListFournisseur(response?.data);
    } catch (error) {
      console.error("Error lors de affiche liste utilisateurs:", error);
      // En cas d'erreur, essayer de charger tous les fournisseurs par défaut
      try {
        const response = await FetchListFournisseur();
        setListFournisseur(response?.data);
      } catch (fallbackError) {
        console.error("Error lors du chargement par défaut:", fallbackError);
      }
    }
  };
  //Cette fonction pour afficher liste des livreurs
  const fetchLivreurData = async () => {
    try {
      const response = await FetchAllLivreur();
      setListLivreur(response.data);
    } catch (error) {
      console.error("Error lors de affiche liste livreur:", error);
    }
  };

  //Cette fonction pour fermer le Pop Up
  const handleOkModalClose = () => {
    setShowOkModal(false);
  };

  const fetchOrderData = async () => {
    try {
      const order = await GetOneCommandeById(idCommande);
      setOrderDetails(order);

      // Pré-remplir avec ce que le client a déjà répondu : seules les étapes
      // laissées à "inconnu" sont réellement à reprendre au téléphone.
      const reprendre = (valeur) => (valeur && valeur !== "inconnu" ? valeur : "");
      setManutentionReponses({
        distance: reprendre(order?.manutention_distance),
        obstacles: reprendre(order?.manutention_obstacles),
        etage: reprendre(order?.manutention_etage),
        ascenseur: reprendre(order?.manutention_ascenseur),
        poids_colis: reprendre(order?.manutention_poids_colis),
      });
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const handleConfirmerManutention = async (mode) => {
    setManutentionEnCours(true);
    setManutentionErreur(null);
    try {
      const payload =
        mode === "montant"
          ? { total_ht: Number(manutentionMontant) }
          : Object.fromEntries(
              Object.entries(manutentionReponses).filter(([, valeur]) => valeur !== "")
            );

      await confirmerManutention(idCommande, payload);
      setManutentionMontant("");
      await fetchOrderData();
    } catch (error) {
      setManutentionErreur(
        error.response?.data?.error ||
          Object.values(error.response?.data?.errors || {})[0]?.[0] ||
          "La confirmation a échoué."
      );
    } finally {
      setManutentionEnCours(false);
    }
  };

  useEffect(() => {
    if (!window.google) {
      const gmapScriptEl = document.createElement("script");
      gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      gmapScriptEl.async = true;
      gmapScriptEl.defer = true;
      gmapScriptEl.onload = () => setIsGMapsLoaded(true);
      document.body.appendChild(gmapScriptEl);
    } else {
      setIsGMapsLoaded(true);
    }
  }, []);
  useEffect(() => {
    if (orderDetails) {
      // setPickUpAdr(orderDetails?.AdressePickUp || "");
      // setAddress(orderDetails?.AdresseLivraison || "");
      // setPickupLatLng({
      //   lat: orderDetails?.altitudeFournisseur || 0,
      //   lng: orderDetails?.longitudeFournisseur || 0,
      // });
      // setDeliveryLatLng({
      //   lat: orderDetails?.altitudeLivreur || 0,
      //   lng: orderDetails?.longitudeLivreur || 0,
      // });
      setFile(orderDetails?.Bordereau);
      setSelectedFournisseurEmail(orderDetails?.emailFournisseur);
      setTelFournisseurVal(orderDetails?.TelFournisseur);
    }
  }, [orderDetails]);
  useEffect(() => {
    fetchOrderData(idCommande);
    fetchLivreurData();
  }, [idCommande]);

  // Charger la liste des utilisateurs selon le type de client de la commande
  useEffect(() => {
    if (orderDetails?.client_type) {
      fetchUsersByType(orderDetails.client_type);
    }
  }, [orderDetails?.client_type]);
  // ,pickupLatLng,deliveryLatLng,address,pickupAdr
  return (
    <Container>
      <div>
        <p className="h6">Accueil / Livraisons / Modification </p>
        <Row className="pt-4 pb-2">
          <Col style={{ display: "flex", alignItems: "center" }}>
            <ClickBack editPage={true} />
            <h1 className="p-1">Modification Livraison</h1>
          </Col>
        </Row>

        {orderDetails && (() => {
          const initialLivraisonHT = orderDetails?.livraisonHT ?? 0;
          const initialTarifBase = orderDetails?.tarif_base ?? 19.90;
          console.log("🔧 Initialisation:", {
            livraisonHT: initialLivraisonHT,
            tarif_base: initialTarifBase,
            orderDetails_livraisonHT: orderDetails?.livraisonHT,
            orderDetails_tarif_base: orderDetails?.tarif_base
          });

          return (
          <Formik
            initialValues={{
              client_type: orderDetails?.client_type || "fournisseur",
              fournisseur: orderDetails?.id_fournisseur ? String(orderDetails.id_fournisseur) : "",
              // TelFournisseur: orderDetails?.TelFournisseur || "",
              telFournisseurVal: orderDetails?.TelFournisseur || "",
              NomClient: orderDetails?.NomClient || "",
              PrenomClient: orderDetails?.PrenomClient || "",
              pickupAdr: orderDetails?.AdressePickUp || "",
              altitude_Fournisseur: orderDetails?.altitudeFournisseur || "",
              longitude_Fournisseur: orderDetails?.longitudeFournisseur || "",
              address: orderDetails?.AdresseLivraison || "",
              altitude_Livreur: orderDetails?.altitudeLivreur || "",
              longitude_Livreur: orderDetails?.longitudeLivreur || "",
              livreur: orderDetails?.id_livreur || "",
              //livreur: "",
              DateCommande: orderDetails?.DateCommande
                ? orderDetails?.DateCommande.substring(0, 16)
                : "",
              DateLivraison: orderDetails?.DateLivraison
                ? orderDetails?.DateLivraison.substring(0, 16)
                : "",
              telephone_client: orderDetails?.TelClient || "",
              RaisonSocialClient: orderDetails?.RaisonSocialClient || "",
              reference_client: orderDetails?.reference_client || "",
              selectedFournisseurEmail: orderDetails?.emailFournisseur || "",
              StatuPaiement: orderDetails?.StatuPaiement || "",
              StatuCommande: orderDetails?.StatuCommande || "",
              files: orderDetails?.Bordereau,
              NBonLivraison: orderDetails?.NBonLivraison,
              MontantCommande: orderDetails?.MontantCommande || "",
              Commentaire: orderDetails?.Commentaire || "",
              livraisonHT: initialLivraisonHT,
              commission: orderDetails?.commission || "",
              TVA: 20,
              TTC: orderDetails?.TTC || "",
              poids: orderDetails?.poids || "",
              poids_label: orderDetails?.poids_label || "",
              poids_supplement: orderDetails?.poids_supplement || 0,
              temps_estime: orderDetails?.temps_estime || "",
              temps_supplement: orderDetails?.temps_supplement || 0,
              tarif_base: initialTarifBase,
              tarif_ht: orderDetails?.tarif_ht || initialLivraisonHT,
              tarif_ttc: orderDetails?.tarif_ttc || "",
              type_livraison: orderDetails?.type_livraison || "",
              livraison_supplement: orderDetails?.livraison_supplement || 0,

            }}
            validationSchema={SignupSchema}
            onSubmit={(values, { setSubmitting }) => {
              console.log("📝 Valeurs du formulaire:", values);
              console.log("💰 livraisonHT:", values.livraisonHT, "Type:", typeof values.livraisonHT);

              // Passage a « paye par carte » sur un client hors compte : on
              // demande une confirmation explicite avant d'enregistrer.
              if (confirmationPaiementRequise(values)) {
                setValeursEnAttente(values);
                setShowPaiementCarteModal(true);
                return;
              }

              HandleSave(values);
              // setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              setErrors,
              touched,
              isInvalid,
              setFieldError,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              validateField,
              setFieldTouched,
              isValid,
              dirty,
            }) => {
              // Debug: afficher les erreurs de validation
              if (Object.keys(errors).length > 0) {
                console.log("❌ Erreurs de validation:", errors);
                console.log("📊 Valeurs actuelles du formulaire:", values);
                console.log("💰 livraisonHT actuel:", values.livraisonHT, "Type:", typeof values.livraisonHT);
              }
              return (
              <Form onSubmit={handleSubmit}>
                {/* Sur une commande facturée, les montants sont figés côté serveur.
                    Laisser AutoCalculateFields recomposer le prix ferait diverger le
                    formulaire de la base — sur une commande remisée il produirait le
                    brut alors que la base contient le net — et l'enregistrement
                    serait refusé en 409 même pour une simple correction d'adresse. */}
                {!montantsFiges && <AutoCalculateFields />}

                {montantsFiges && (
                  <div
                    className="mb-3 px-3 py-2"
                    style={{
                      background: "#fffbeb",
                      borderLeft: "4px solid #f59e0b",
                      borderRadius: "6px",
                      fontSize: "0.9rem",
                      color: "#78350f",
                    }}
                  >
                    Commande déjà facturée : les montants sont figés et ne peuvent plus être
                    modifiés ici. Le reste de la fiche reste éditable. Pour régulariser une
                    somme, émettre un avoir depuis la vue détail.
                  </div>
                )}
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title className="pb-3">
                      Détails de la commande
                    </Card.Title>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="clientType"
                        >
                          <Form.Label>Type de client *</Form.Label>
                          <Form.Select
                            className="form-control"
                            value={values.client_type}
                            name="client_type"
                            onChange={(e) => {
                              handleChange(e);
                              const newType = e.target.value;
                              // Reset fields when changing type
                              setFieldValue('fournisseur', '');
                              setFieldValue('selectedFournisseurEmail', '');
                              setSelectedFournisseurEmail('');
                              if (newType !== 'fournisseur') {
                                setFieldValue('telFournisseurVal', '');
                                setTelFournisseurVal('');
                              }
                              // Charger la nouvelle liste d'utilisateurs
                              fetchUsersByType(newType);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.client_type && !!errors.client_type
                            }
                          >
                            <option value="fournisseur">🏢 Fournisseur</option>
                            <option value="particulier">👤 Particulier</option>
                            <option value="entreprise">💼 Entreprise (Pro)</option>
                          </Form.Select>
                          <ErrorMessage
                            name="client_type"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="listFournisseur"
                        >
                          <Form.Label>
                            {values.client_type === 'fournisseur' && '🏢 Fournisseur *'}
                            {values.client_type === 'particulier' && '👤 Client Particulier *'}
                            {values.client_type === 'entreprise' && '💼 Client Entreprise *'}
                          </Form.Label>
                          <Form.Select
                            className="form-control"
                            value={values.fournisseur}
                            name="fournisseur"
                            onChange={(e) => {
                              handleChange(e);
                              handleChangeFournisseur(e, setFieldValue);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.fournisseur && !!errors.fournisseur
                            }
                          >
                            <option value="" disabled hidden>
                              Sélectionnez un utilisateur
                            </option>
                            {listFournisseurs.length > 0 ? (
                              listFournisseurs.map((fournisseur) => (
                                <option
                                  key={fournisseur.id}
                                  value={fournisseur.id}
                                >
                                  {values.client_type === 'particulier'
                                    ? `${fournisseur?.user_profil?.Nom || ''} ${fournisseur?.user_profil?.Prenom || ''}`.trim() || fournisseur?.email
                                    : fournisseur?.user_profil?.RaisonSocial || fournisseur?.email}
                                </option>
                              ))
                            ) : (
                              <option disabled>
                                Aucun utilisateur disponible
                              </option>
                            )}
                          </Form.Select>
                          <ErrorMessage
                            name="fournisseur"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formEmail_client"
                        >
                          <Form.Label>
                            {values.client_type === 'fournisseur' && 'Adresse mail fournisseur *'}
                            {values.client_type === 'particulier' && 'Adresse mail particulier *'}
                            {values.client_type === 'entreprise' && 'Adresse mail entreprise *'}
                          </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="email"
                            placeholder="nom@exemple.com"
                            name="selectedFournisseurEmail"
                            value={
                              values?.email_fournisseur ||
                              selectedFournisseurEmail
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              setSelectedFournisseurEmail(value);
                              setFieldValue("selectedFournisseurEmail", value);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.selectedFournisseurEmail &&
                              !!errors.selectedFournisseurEmail
                            }
                          />
                          <ErrorMessage
                            name="selectedFournisseurEmail"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      {values.client_type === 'fournisseur' && (
                        <Col>
                          <Form.Group
                            className="mb-3"
                            controlId="formtelFournisseurVal"
                          >
                            <Form.Label>N° de téléphone Fournisseur </Form.Label>
                            <Form.Control
                              className="form-control"
                              type="text"
                              name="telFournisseurVal"
                              placeholder="N° de téléphone"
                              value={values?.TelFournisseur || telFournisseurVal}
                              onChange={(e) => {
                                const value = e.target.value;
                                setTelFournisseurVal(value);
                                setFieldValue("telFournisseurVal", value);
                              }}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.telFournisseurVal &&
                                !!errors.telFournisseurVal
                              }
                            />
                            <ErrorMessage
                              name="telFournisseurVal"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formNom_Nomclient"
                        >
                          <Form.Label>Nom Client </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="NomClient"
                            placeholder="Nom Client"
                            value={values.NomClient}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.NomClient && !!errors.NomClient}
                          />
                          <ErrorMessage
                            name="NomClient"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formPrenom_client"
                        >
                          <Form.Label>Prénom Client </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="PrenomClient"
                            placeholder="Prénom Client"
                            value={values.PrenomClient}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.PrenomClient && !!errors.PrenomClient
                            }
                          />
                          <ErrorMessage
                            name="PrenomClient"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formTelephone_client"
                        >
                          <Form.Label>N° de téléphone client </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="telephone_client"
                            placeholder="Télephone Client"
                            value={values.telephone_client}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.telephone_client &&
                              !!errors.telephone_client
                            }
                          />
                          <ErrorMessage
                            name="telephone_client"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      {values.client_type !== 'particulier' && (
                        <Col>
                          <Form.Group
                            className="mb-3"
                            controlId="formRaisonSocial_client"
                          >
                            <Form.Label>Raison Social Client </Form.Label>
                            <Form.Control
                              className="form-control"
                              type="text"
                              name="RaisonSocialClient"
                              placeholder="Raison Social Client"
                              value={values.RaisonSocialClient}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.RaisonSocialClient &&
                                !!errors.RaisonSocialClient
                              }
                            />
                            <ErrorMessage
                              name="RaisonSocialClient"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      )}
                      {/* Sans condition sur le type de client, contrairement au
                          champ ci-dessus : le formulaire client ne propose la
                          reference qu'aux negoces, mais le back-office est
                          l'outil de correction, et une coquille se corrige quel
                          que soit le segment auquel le compte est tague. */}
                      <Col>
                        <Form.Group className="mb-3" controlId="formReferenceClient">
                          <Form.Label>Référence client</Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="reference_client"
                            maxLength={50}
                            placeholder="N° de bon de commande, de chantier…"
                            value={values.reference_client}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.reference_client && !!errors.reference_client
                            }
                          />
                          <Form.Text className="text-muted">
                            Saisie par le client. Figure sur sa facture.
                          </Form.Text>
                          <ErrorMessage
                            name="reference_client"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="listLivreur">
                          <Form.Label>Livreur</Form.Label>
                          {/* Effort sur place, pour choisir le livreur. Reflète la
                              commande enregistrée, pas les modifications en cours. */}
                          {orderDetails?.estimation_manutention && (
                            <div className="mb-2">
                              <BadgeEstimationManutention estimation={orderDetails.estimation_manutention} />
                              {orderDetails.estimation_manutention.deux_personnes && (
                                <span className="badge bg-warning text-dark ms-1">👥 2 livreurs</span>
                              )}
                            </div>
                          )}
                          <Form.Select
                            className="form-control"
                            value={values.livreur}
                            name="livreur"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.livreur && !!errors.livreur}
                          >
                            <option value="" disabled hidden>
                              Sélectionnez un livreur
                            </option>
                            {listLivreur?.map((livreur) => (
                              <option key={livreur.id} value={livreur.id}>
                                {livreur.nom} {livreur.prenom}
                              </option>
                            ))}
                          </Form.Select>
                          <ErrorMessage
                            name="livreur"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>

                        {/* Afficher la disponibilité des livreurs */}
                        <LivreurDisponibilite
                          dateLivraison={values.DateLivraison}
                          selectedLivreurId={values.livreur}
                          onSelectLivreur={(livreurId) => {
                            setFieldValue('livreur', livreurId);
                          }}
                        />
                      </Col>
                      {/* <Col>
                        <Form.Label>Date de la commande : </Form.Label>
                        <input
                          type="datetime-local" // Définition du type datetime-local
                          id="DateCommande"
                          name="DateCommande"
                          className={`form-control ${
                            touched.DateCommande && errors.DateCommande
                              ? "danger-input"
                              : ""
                          }`}
                          value={values.DateCommande}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.DateCommande && !!errors.DateCommande
                          }
                        />
                        <ErrorMessage
                          name="DateCommande"
                          component="div"
                          className="text-danger"
                        />
                      </Col> */}
                      
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formBordereau">
                          <Form.Label>
                            Bordereau{" "}
                            {values?.files && (
                              <b> : Un fichier Attaché {values?.files}</b>
                            )}
                          </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="file"
                            name="file"
                            placeholder="Bordereau"
                            accept=".pdf"
                            //value={values.Bordereau}
                            onChange={(event) => {
                              const elemtFile = event.currentTarget.files[0];
                              setFile(elemtFile);
                              handelUpload(elemtFile, setFieldValue);
                            }}
                            onBlur={handleBlur}
                            isInvalid={touched.file && !!errors.file}
                          />
                          <ErrorMessage
                            name="file"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="formLastName">
                          <Form.Label>Statut de Commande</Form.Label>
                          <Form.Select
                            className="form-control"
                            type="text"
                            name="StatuCommande"
                            placeholder="statut commande"
                            value={values.StatuCommande}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.StatuCommande && !!errors.StatuCommande
                            }
                          >
                            <option>Sélectionnez le Statut de Commande</option>
                            <option value="4">En cours de validation</option>
                            <option value="1">En cours de livraison</option>
                            <option value="2">Livré</option>
                            <option value="3">En cours de préparation</option>
                            <option value="6">Annulé</option>
                          </Form.Select>
                          <ErrorMessage
                            name="statut_commande"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formStatutPaiement"
                        >
                          <Form.Label>Statut de paiement</Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            className="form-control"
                            id="StatuPaiement"
                            name="StatuPaiement"
                            placeholder="Statut paiement"
                            value={values.StatuPaiement}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.StatuPaiement && !!errors.StatuPaiement
                            }
                          >
                            <option>Sélectionnez le Statut de paiement</option>
                            <option value="1">Facturé</option>
                            <option value="2">Non Facturé</option>
                            <option value="3">Paiement réussie (marion-livraison)</option>
                            <option value="4">Paiement non réussie  (marion-livraison)</option>
                            <option value="6">Offert</option>
                          </Form.Select>
                          <ErrorMessage
                            name="StatuPaiement"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row></Row>
                    {isGMapsLoaded && (
                      <Row>
                        <Col>
                          <Form.Group
                            className="mb-3"
                            controlId="formAddressPickup"
                          >
                            <Form.Label>Adresse Pick Up</Form.Label>
                            <PlacesAutocompleteComponent
                              name="pickupAdr"
                              hasCoordinates={!!(values.altitude_Fournisseur && values.longitude_Fournisseur)}
                              value={values.pickupAdr}
                              setFieldValue={setFieldValue}
                              searchOptions={searchOptions}
                              setFieldTouched={setFieldTouched}
                              handleFieldBlur={() => handleBlur("pickupAdr")} 
                              setFieldError={setFieldError} 
                              isInvalid={
                                touched.pickupAdr && !!errors.pickupAdr
                              }
                          />
                            <ErrorMessage
                              name="pickupAdr"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>

                        <Col>
                          <Form.Group className="mb-3" controlId="formAddress">
                            <Form.Label>Adresse Livraison</Form.Label>
                            <PlacesAutocompleteComponent
                              name="address"
                              hasCoordinates={!!(values.altitude_Livreur && values.longitude_Livreur)}
                              value={values.address}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                              searchOptions={searchOptions}
                              handleFieldBlur={() => handleBlur("address")} 
                              setFieldError={setFieldError} 
                              isInvalid={
                                touched.address && !!errors.address
                              }
                           />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formBondelivraison"
                        >
                          <Form.Label>Numéro Bon de livraison</Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="NBonLivraison"
                            placeholder="Numéro Bon de livraison"
                            value={values.NBonLivraison}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.NBonLivraison && !!errors.NBonLivraison
                            }
                          />
                          <ErrorMessage
                            name="NBonLivraison"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formCommentaire"
                        >
                          <Form.Label>Commentaire</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            className="form-control"
                            name="Commentaire"
                            placeholder="Commentaire"
                            value={values.Commentaire}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            maxLength={500}
                            isInvalid={
                              touched.Commentaire && !!errors.Commentaire
                            }
                          />
                          <Form.Text className="text-muted">
                            {values.Commentaire?.length || 0}/500 caractères
                          </Form.Text>
                          <ErrorMessage
                            name="Commentaire"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formMontantCommande"
                        >
                          <Form.Label>Montant marchandise</Form.Label>
                          <Form.Control
                            className="form-control"
                            type="number"
                            name="MontantCommande"
                            placeholder="Montant marchandise"
                            value={values.MontantCommande}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.MontantCommande &&
                              !!errors.MontantCommande
                            }
                          />
                          <ErrorMessage
                            name="MontantCommande"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {/* Montants */}
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title className="pb-3">Montants :</Card.Title>
                    <Row>
                      
                      <Col>
                        <Form.Group className="mb-3" controlId="formTarifBase">
                          <Form.Label>Tarif base (€)</Form.Label>
                          <Field
                            type="number"
                            name="tarif_base"
                            placeholder="Tarif base"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="formPoidsSupplement">
                          <Form.Label>Poids Supplément (€)</Form.Label>
                          <Field
                            type="number"
                            name="poids_supplement"
                            placeholder="Poids Supplément"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="poids_supplement"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="formTempsSupp">
                          <Form.Label>Temps Supplément (€)</Form.Label>
                          <Field
                            type="number"
                            name="temps_supplement"
                            placeholder="Temps supplément"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group className="mb-3" controlId="formSuppLivraison">
                          <Form.Label>Supp. Livraison (€)</Form.Label>
                          <Field
                            type="number"
                            name="livraison_supplement"
                            placeholder="Supp. Livraison"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col>
                        <Form.Group className="mb-3" controlId="formCommission">
                          <Form.Label>Commission %</Form.Label>
                          <Field
                            type="number"
                            name="commission"
                            placeholder="Commission %"
                            className="form-control"
                            value={values?.commission || comissionVal}
                            onChange={(e) => {
                              const value = e.target.value;
                              setComissionVal(value);
                              setFieldValue("commission", value);
                            }}
                          />
                          <ErrorMessage
                            name="commission"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>*/}
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formTarifLivraison"
                        >
                          <Form.Label>Tarif de Livraison</Form.Label>
                          <Form.Control
                            type="text"
                            name="livraisonHT"
                            value={values.livraisonHT ?? ''}
                            placeholder="Tarif de Livraison"
                            className="form-control"
                            readOnly
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage
                            name="livraisonHT"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      
                      
                      
                      <Col>
                        <Form.Group className="mb-3" controlId="formtva">
                          <Form.Label>TVA</Form.Label>
                          <Field
                            type="number"
                            name="TVA"
                            placeholder="TVA"
                            className="form-control"
                            disabled="true"
                          />
                          <ErrorMessage
                            name="TVA"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3" controlId="formMontantTTC">
                          <Form.Label>Montant TTC</Form.Label>
                          <Field
                            type="number"
                            name="TTC"
                            placeholder="Montant TTC"
                            className="form-control"
                            value={values?.TTC}
                            disabled="true"
                          />
                          <ErrorMessage
                            name="TTC"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {/* transport */}
                <Card className="mb-3">
                  <Card.Body>
                    <Card.Title className="pb-3">Détails transport :</Card.Title>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formPoids">
                          <Form.Label>Poids livraison (en kilos)</Form.Label>
                          <Field
                            as="select"
                            name="poids"
                            className="form-control"
                            onChange={(e) => {
                              const selected = e.target.value;
                              setFieldValue("poids", selected);
                              if (
                                ![
                                  "-150",
                                  "151-300",
                                  "301-450",
                                  "451-600",
                                  "601-750",
                                  "751-900",
                                  "901-1350",
                                ].includes(selected)
                              ) {
                                setFieldValue("poids_autre", selected);
                              } else {
                                setFieldValue("poids_autre", "");
                              }
                            }}
                            value={values.poids}
                          >
                            <option value="">Poids livraison (en kilos)</option>
                            <option value="-150">- de 150 kilos</option>
                            <option value="151-300">151 à 300 Kg</option>
                            <option value="301-450">301 à 450 Kg</option>
                            <option value="451-600">451 à 600 Kg</option>
                            <option value="601-750">601 à 750 Kg</option>
                            <option value="751-900">751 à 900 Kg</option>
                            <option value="901-1350">901 à 1350 Kg</option>
                            <option value="autre">Autre...</option>
                          </Field>

                          {/* Champ texte si poids personnalisé */}
                          {[
                            "-150",
                            "151-300",
                            "301-450",
                            "451-600",
                            "601-750",
                            "751-900",
                            "901-1350",
                          ].includes(values.poids) ? null : (
                            <Field
                              type="text"
                              name="poids"
                              className="form-control mt-2"
                              placeholder="Entrez un poids personnalisé"
                              onChange={handleChange}
                            />
                          )}
                        </Form.Group>

                      </Col>

                      <Col>
                        <Form.Label>Heure de livraison souhaitée: </Form.Label>
                        <input
                          type="datetime-local" // Définition du type datetime-local
                          id="DateLivraison"
                          name="DateLivraison"
                          className={`form-control ${
                            touched.DateLivraison && errors.DateLivraison
                              ? "danger-input"
                              : ""
                          }`}
                          value={values.DateLivraison}
                          placeholder=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.DateLivraison && !!errors.DateLivraison
                          }
                        />
                        <ErrorMessage
                          name="DateLivraison"
                          component="div"
                          className="text-danger"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="mb-3" controlId="formTempsEstime">
                          <Form.Label>Temps estimé (min)</Form.Label>
                          <Field
                            type="number"
                            name="temps_estime"
                            placeholder="Temps estimé"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="formTypeLivraison">
                          <Form.Label>Type de Livraison</Form.Label>
                          <Field
                            as="select"
                            name="type_livraison"
                            className="form-control"
                          >
                            <option value="">Sélectionnez</option>
                            <option value="planifiee">Planifiée</option>
                            <option value="urgent">Urgent</option>
                            <option value="flex">Flex</option>
                          </Field>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* Bloc manutention — affiché uniquement si le client a pris des options de manutention */}
                {(orderDetails?.manutention_status || orderDetails?.manutention_total_ttc > 0) && (
                  <Card className="mb-3 border-warning">
                    <Card.Body>
                      <Card.Title className="pb-3">🏗️ Options de manutention</Card.Title>
                      <Row className="pb-3">
                        <Col>
                          <p><strong>Étage : </strong>{orderDetails?.manutention_etage ?? "—"}</p>
                        </Col>
                        <Col>
                          <p><strong>Ascenseur : </strong>{libelleAscenseur(orderDetails?.manutention_ascenseur)}</p>
                        </Col>
                        <Col>
                          <p><strong>Marches estimées : </strong>{orderDetails?.manutention_marches_estimees ?? "—"}</p>
                        </Col>
                      </Row>
                      <Row className="pb-3">
                        <Col>
                          <p>
                            <strong>Distance de portage : </strong>{orderDetails?.manutention_distance ?? "—"}
                            {orderDetails?.manutention_distance_supplement > 0 && (
                              <> (supplément : {Number(orderDetails.manutention_distance_supplement).toFixed(2)} € HT)</>
                            )}
                          </p>
                        </Col>
                        <Col>
                          <p>
                            <strong>Obstacles : </strong>{orderDetails?.manutention_obstacles ?? "—"}
                            {orderDetails?.manutention_obstacles_supplement > 0 && (
                              <> (supplément : {Number(orderDetails.manutention_obstacles_supplement).toFixed(2)} € HT)</>
                            )}
                          </p>
                        </Col>
                        <Col>
                          <p>
                            <strong>Poids colis le plus lourd : </strong>{orderDetails?.manutention_poids_colis ?? "—"}
                            {orderDetails?.manutention_poids_colis_supplement > 0 && (
                              <> (supplément : {Number(orderDetails.manutention_poids_colis_supplement).toFixed(2)} € HT)</>
                            )}
                          </p>
                        </Col>
                      </Row>
                      {orderDetails?.manutention_description_acces && (
                        <Row className="pb-3">
                          <Col>
                            <p><strong>Description accès : </strong>{orderDetails.manutention_description_acces}</p>
                          </Col>
                        </Row>
                      )}
                      <Row className="pb-3">
                        <Col>
                          <p>
                            <strong>Supplément poids total : </strong>
                            {orderDetails?.manutention_poids_total_supplement > 0
                              ? `${Number(orderDetails.manutention_poids_total_supplement).toFixed(2)} € HT`
                              : "—"}
                          </p>
                        </Col>
                        <Col>
                          <p>
                            <strong>Total manutention : </strong>
                            {orderDetails?.manutention_status === "a_confirmer" ? (
                              <span className="text-warning fw-bold">À confirmer</span>
                            ) : (
                              <>
                                {Number(orderDetails?.manutention_total_ht ?? 0).toFixed(2)} € HT / {Number(orderDetails?.manutention_total_ttc ?? 0).toFixed(2)} € TTC
                              </>
                            )}
                          </p>
                        </Col>
                        <Col />
                      </Row>
                      {/* Le formulaire ne s'affichait que pour les manutentions
                          « à confirmer » : une fois chiffrée, plus aucun moyen de
                          la corriger, même sur une commande non facturée. Depuis
                          que les livreurs saisissent eux-mêmes, c'est justement
                          la correction qui manquait — relire sans pouvoir
                          rectifier ne sert à rien.

                          La limite est désormais celle qui protège réellement
                          l'argent : facture émise ou montant encaissé. */}
                      {orderDetails?.manutention_modifiable === false && (
                        <Row>
                          <Col>
                            <div className="alert alert-secondary mb-0">
                              🔒 {orderDetails.motif_verrou_montant}
                            </div>
                          </Col>
                        </Row>
                      )}
                      {orderDetails?.manutention_modifiable !== false && (
                        <>
                          {orderDetails?.manutention_status === "a_confirmer" ? (
                            <Row>
                              <Col>
                                <div className="alert alert-warning">
                                  ⚠️ Manutention à confirmer manuellement avant livraison.
                                  Tant qu'elle ne l'est pas, le montant vaut 0 € et c'est ce
                                  montant qui sera facturé.
                                </div>
                              </Col>
                            </Row>
                          ) : orderDetails?.manutention_saisie?.source === "livreur" && (
                            <Row>
                              <Col>
                                <div className="alert alert-info">
                                  Chiffrée par le livreur
                                  {orderDetails.manutention_saisie.par && <> ({orderDetails.manutention_saisie.par})</>}
                                  {orderDetails.manutention_saisie.le_texte && <> le {orderDetails.manutention_saisie.le_texte}</>}.
                                  Corrigeable ici tant que la facture n'est pas émise.
                                </div>
                              </Col>
                            </Row>
                          )}

                          {manutentionErreur && (
                            <Row>
                              <Col>
                                <div className="alert alert-danger">{manutentionErreur}</div>
                              </Col>
                            </Row>
                          )}

                          <Row className="pb-2">
                            <Col>
                              <p className="mb-1">
                                <strong>
                                  {orderDetails?.manutention_status === "a_confirmer"
                                    ? "Confirmer avec le barème"
                                    : "Corriger le chiffrage"}
                                </strong>
                              </p>
                              <p className="small text-muted">
                                {orderDetails?.manutention_status === "a_confirmer"
                                  ? "Reprendre les réponses avec le client. Seules celles laissées à « je ne sais pas » sont vides ci-dessous."
                                  : "Les réponses actuelles sont reprises ci-dessous. Enregistrer recalcule le montant et remplace la saisie précédente."}
                              </p>
                            </Col>
                          </Row>
                          <Row className="pb-2">
                            <Col md={4}>
                              <Form.Label>Distance de portage</Form.Label>
                              <Form.Select
                                value={manutentionReponses.distance}
                                onChange={(e) =>
                                  setManutentionReponses({ ...manutentionReponses, distance: e.target.value })
                                }
                              >
                                <option value="">— À renseigner —</option>
                                <option value="0-5">0 à 5 m</option>
                                <option value="5-15">5 à 15 m</option>
                                <option value="15-30">15 à 30 m</option>
                                <option value="30-50">30 à 50 m</option>
                                <option value="50+">Plus de 50 m</option>
                              </Form.Select>
                            </Col>
                            <Col md={4}>
                              <Form.Label>Obstacles</Form.Label>
                              <Form.Select
                                value={manutentionReponses.obstacles}
                                onChange={(e) =>
                                  setManutentionReponses({ ...manutentionReponses, obstacles: e.target.value })
                                }
                              >
                                <option value="">— À renseigner —</option>
                                <option value="aucun">Aucun</option>
                                <option value="quelques">Quelques-uns</option>
                                <option value="difficile">Accès difficile</option>
                              </Form.Select>
                            </Col>
                            <Col md={4}>
                              <Form.Label>Poids du colis le plus lourd</Form.Label>
                              <Form.Select
                                value={manutentionReponses.poids_colis}
                                onChange={(e) =>
                                  setManutentionReponses({ ...manutentionReponses, poids_colis: e.target.value })
                                }
                              >
                                <option value="">— À renseigner —</option>
                                <option value="normal">Normal</option>
                                <option value="lourd">Lourd</option>
                              </Form.Select>
                            </Col>
                          </Row>
                          <Row className="pb-3">
                            <Col md={4}>
                              <Form.Label>Ascenseur</Form.Label>
                              <Form.Select
                                value={manutentionReponses.ascenseur}
                                onChange={(e) =>
                                  setManutentionReponses({ ...manutentionReponses, ascenseur: e.target.value })
                                }
                              >
                                <option value="">— À renseigner —</option>
                                <option value="oui">Oui</option>
                                <option value="non">Non</option>
                              </Form.Select>
                            </Col>
                            <Col md={4}>
                              <Form.Label>Étage</Form.Label>
                              <Form.Select
                                value={manutentionReponses.etage}
                                onChange={(e) =>
                                  setManutentionReponses({ ...manutentionReponses, etage: e.target.value })
                                }
                              >
                                <option value="">— À renseigner —</option>
                                <option value="non_concerne">Non concerné</option>
                                <option value="rdc_surleve">RDC surélevé</option>
                                <option value="1er">1er étage</option>
                                <option value="2e_plus">2e étage ou plus</option>
                              </Form.Select>
                            </Col>
                            <Col md={4} className="d-flex align-items-end">
                              <Button
                                type="button"
                                variant="primary"
                                disabled={manutentionEnCours || !manutentionReponses.distance}
                                onClick={() => handleConfirmerManutention("bareme")}
                              >
                                {manutentionEnCours ? "Calcul…" : "Calculer et confirmer"}
                              </Button>
                            </Col>
                          </Row>

                          <Row className="pb-2 border-top pt-3">
                            <Col>
                              <p className="mb-1">
                                <strong>Ou saisir un montant négocié</strong>
                              </p>
                              <p className="small text-muted">
                                Pour le cas exceptionnel (plus de 50 m, accès difficile et sans
                                ascenseur), que le barème ne tarife pas.
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <Form.Label>Montant négocié (€ HT)</Form.Label>
                              <Form.Control
                                type="number"
                                min="0"
                                max="500"
                                step="0.01"
                                value={manutentionMontant}
                                onChange={(e) => setManutentionMontant(e.target.value)}
                              />
                            </Col>
                            <Col md={4} className="d-flex align-items-end">
                              <Button
                                type="button"
                                variant="outline-primary"
                                disabled={manutentionEnCours || manutentionMontant === ""}
                                onClick={() => handleConfirmerManutention("montant")}
                              >
                                {manutentionEnCours ? "Enregistrement…" : "Confirmer ce montant"}
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                )}

                <Row>
                  <Col>
                    <Form.Group
                      className="mt-3 d-flex justify-content-end align-items-center"
                      controlId="formSubmit"
                    >
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={
                           isSubmitting
                        }
                      >
                        Enregistrer la livraison
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              );
            }}
          </Formik>
          );
        })()}

        {/* Section POD Images - Affichée après le formulaire */}
        {orderDetails && (
          <PODImages commandeId={idCommande} readOnly={false} />
        )}
      </div>
      <ModalValidation
        show={showOkModal}
        onClose={handleOkModalClose}
        onConfirm={handleOkModalClose}
        text={"Votre commande a été enregistrée et envoyer avec succès"}
      />

      <ConfirmationPaiementCarte
        show={showPaiementCarteModal}
        commandeId={idCommande}
        onClose={() => {
          // On n'enregistre rien et on ne touche pas au formulaire : le statut
          // reste sur 3 a l'ecran, l'admin peut le corriger ou reessayer.
          setShowPaiementCarteModal(false);
          setValeursEnAttente(null);
        }}
        onConfirm={() => {
          setShowPaiementCarteModal(false);
          if (valeursEnAttente) {
            HandleSave(valeursEnAttente);
            setValeursEnAttente(null);
          }
        }}
      />
    </Container>
  );
}

export default EditCommandeFournisseur;
